module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/05-9a0015d72e0b04214a49fa4c0003123d.png";